/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {FormattedMessage, injectIntl} from 'react-intl';
import {Grid, Tab, Select, Divider} from '@scuf/common';
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router";
import Users from "./users/Users";
import LearningLoop from "./learningLoop/LearningLoop";
import {ACTIVITY_TYPES} from '../security/SecurityConst'
import {userHasActivity} from '../security/SecurityUtils'
import * as UserActions from './users/UserActions'
import {bindActionCreators} from "redux";
import AppConfig from './appConfig/AppConfig'
import Fleets from "./fleets/Fleets";
import {Routes} from "../utils/Routes";
import Assets from "./assets/Assets";

class AdminMenu extends React.Component {
    constructor(props) {
        super(props)

        const {match:{url}} = this.props

        this.state = {
            tabIndex: 0,
        }

        if(url.indexOf(Routes.USERS) !== -1) {
            this.state.tabIndex = 0
        } else if(url.indexOf(Routes.FLEETS_ADMIN) !== -1 || url.indexOf(Routes.ASSETS_ADMIN) !== -1) {
            this.state.tabIndex = 1
        } else if(url.indexOf(Routes.LEARNING_LOOP_ADMIN) !== -1) {
            this.state.tabIndex = 2
        } else if(url.indexOf(Routes.APP_CONFIG_ADMIN) !== -1) {
            this.state.tabIndex = 3
        }

        this.changeTab = this.changeTab.bind(this)

    }

    changeTab(index) {
        const {history, userProfile} = this.props;
        this.setState({tabIndex: index});

        if(index === 0) {
            history.push(Routes.USERS)
        } else if(index === 1) {
            if (userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
                history.push(Routes.ASSETS_ADMIN)
            } else {
                history.push(Routes.FLEETS_ADMIN)
            }
        } else if(index === 2) {
            history.push(Routes.LEARNING_LOOP_ADMIN)
        } else if(index === 3) {
            history.push(Routes.APP_CONFIG_ADMIN)
        }
    }

    renderMobileMenuButton() {
        const {intl} = this.props;
        let menuOptions;
        if (userHasActivity(this.props.userProfile, ACTIVITY_TYPES.FLEETS_READ)) {
            menuOptions = [{value: 0, text: intl.formatMessage({id: "admin.tab.users"})},
                {value: 1, text: intl.formatMessage({id: "admin.tab.fleets.and.assets"})},
                {value: 2, text: intl.formatMessage({id: "admin.tab.learningLoop"})},
                {value: 3, text: intl.formatMessage({id: "admin.tab.appConfig"})}]
        } else {
            menuOptions = [{value: 0, text: intl.formatMessage({id: "admin.tab.users"})},
                {value: 1, text: intl.formatMessage({id: "admin.tab.only.assets"})},
                {value: 2, text: intl.formatMessage({id: "admin.tab.learningLoop"})},
                {value: 3, text: intl.formatMessage({id: "admin.tab.appConfig"})}]
        }

        return (
            <div className="admin-mobile-menu">
                <Select value={this.state.tabIndex} options={menuOptions} onChange={(value)=> (this.changeTab(value))} fluid/>
                <Divider />
            </div>
        )
    }


    render() {
        return (
            <div>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={8} sWidth={12}>
                            <h2><FormattedMessage id="administration" /></h2>
                        </Grid.Column>
                        <Grid.Column width={4} sWidth={12} className="align-right">
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                {this.renderMobileMenuButton()}

                <Tab onTabChange={(activeIndex) => (this.changeTab(activeIndex))} renderActiveOnly={true} activeIndex={this.state.tabIndex} className="administration-tab">
                    {this.getUserTab()}
                    {this.getFleetsTab()}
                    {this.getLearningLoopTab()}
                    {this.getAppConfigTab()}
                </Tab>
            </div>
        )
    }

    getUserTab() {
        const {intl} = this.props
        if (userHasActivity(this.props.userProfile, ACTIVITY_TYPES.USERS_READ)) {
            return (
                <Tab.Pane title={intl.formatMessage({id: "admin.tab.users"})}>
                    <Users/>
                </Tab.Pane>
            )
        }
        return null
    }

    getLearningLoopTab() {
        const {intl} = this.props
        if (userHasActivity(this.props.userProfile, ACTIVITY_TYPES.CONFIG_READ)) {
            return (
                <Tab.Pane title={intl.formatMessage({id: "admin.tab.learningLoop"})}>
                    <LearningLoop />
                </Tab.Pane>
            )
        }
        return null
    }

    getAppConfigTab() {
        const {intl} = this.props
        if (userHasActivity(this.props.userProfile, ACTIVITY_TYPES.CONFIG_READ)) {
            return (
                <Tab.Pane title={intl.formatMessage({id: "admin.tab.appConfig"})}>
                    <AppConfig />
                </Tab.Pane>
            )
        }
        return null
    }

    getFleetsTab() {
        const {intl} = this.props
        if (userHasActivity(this.props.userProfile, ACTIVITY_TYPES.FLEETS_READ)) {
            return (
                <Tab.Pane title={intl.formatMessage({id: "admin.tab.fleets.and.assets"})}>
                    <Fleets />
                </Tab.Pane>
            )
        }
        if (userHasActivity(this.props.userProfile, ACTIVITY_TYPES.ASSETS_READ)) {
            return (
                <Tab.Pane title={intl.formatMessage({id: "admin.tab.only.assets"})}>
                    <Assets />
                </Tab.Pane>
            )
        }
        return null
    }
}

const mapStateToProps = (state) => {
    return {
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        UserActions: bindActionCreators(UserActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminMenu)))
